import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatAlert = createCustomElementWrapper('kat-alert', 'KatAlert', {}, {
    'onDismiss': 'dismiss',
}, [
    'header',
    'cta',
]);
